import { useCallback, useEffect, useState } from "react";

export const useResize = (resizeRef: React.RefObject<HTMLElement>, dependencies: any[] = []) => {
  const [width, setWidth] = useState(0)
  const [height, setHeight] = useState(0)

  const handleWidthResize = useCallback(() => {
    if (resizeRef.current) {
      setWidth(resizeRef.current.offsetWidth);
    }
  }, [resizeRef])

  useEffect(() => {
    handleWidthResize();
    window.addEventListener('resize', handleWidthResize)

    return () => {
      window.removeEventListener('resize', handleWidthResize)
    }
  }, [resizeRef, handleWidthResize, ...dependencies])

  const handleHeightResize = useCallback(() => {
    if (resizeRef.current) {
      setHeight(resizeRef.current.offsetHeight);
    }
  }, [resizeRef])

  useEffect(() => {
    handleHeightResize();
    window.addEventListener('resize', handleHeightResize)

    return () => {
      window.removeEventListener('resize', handleHeightResize)
    }
  }, [resizeRef, handleHeightResize, ...dependencies])

  useEffect(() => {
    handleHeightResize();
    handleWidthResize();
  }, []);

  useEffect(() => {
    handleHeightResize();
    handleWidthResize();
  }, [...dependencies]);

  return {width, height}
}

export default useResize;